<template>
    <!-- 下载中心 -->
    <div class="download">
        <div class="container row">
            <div class="col-lg-6">
                <div class="container_box">
                    <h4 class="fw_900">{{ $t('download.title') }}</h4>
                    <div class="download-buttons">
                        <a
                            :href="storeUrls.appStore"
                            class="download-btn apple"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src="/img/pay/apple.png" :alt="$t('download.appStore')">
                            <span>{{ $t('download.appStore') }}</span>
                        </a>
                        <a
                            :href="storeUrls.googlePlay"
                            class="download-btn android"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src="/img/pay/android.png" alt="Google Play">
                            <span>{{ $t('download.googlePlay') }}</span>
                        </a>
                        <a
                            :href="storeUrls.huawei"
                            class="download-btn huawei"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src="/img/pay/huawei.png" :alt="$t('download.huaweiAppGallery')">
                            <span>{{ $t('download.huaweiAppGallery') }}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="container_img">
                    <img src="/img/pay/0--53.png" alt="手机截图1" class="phone1">
                    <img src="/img/pay/0--31.png" alt="手机截图2" class="phone2">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'download',
    data() {
        return {
            title: this.$t('nav.download'),
            storeUrls: {
                appStore: 'https://apps.apple.com/kh/app/lantonpay/id6749543288',
                googlePlay: 'https://play.google.com/store/apps/details?id=com.lantoncloud.lantonpay',
                huawei: 'https://appgallery.huawei.com/app/C114912263',
            },
        }
    },
}
</script>
<style scoped lang="scss">
.download {
    height: var(--main-height);
    background-image: url('/img/pay/0-_BG-3.png');
    background-position: bottom;
    background-size: cover;
    display: flex;
    justify-content: center;
    // align-items: center;
    // padding: 0 50px;
}

.container_box {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
}

.container_img {
    position: absolute;
    bottom: 0;
    right: 0;
    text-align: right;
}

.container {
    display: flex;
    height: 100%;

    >div {
        height: 100%;
    }
}

.fw_900 {
    font-weight: 900;
}

.c_233dd2 {
    color: #233dd2;
}

.download-buttons {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    margin-top: 80px;
    gap: 12px;
    padding: 0 8px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
}

.download-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    flex: 1 1 0;
    min-width: 96px;
    width: auto;
    max-width: 210px;
    height: 65px;
    padding: 0 clamp(8px, 1.5vw, 18px);
    border-radius: 4px;
    background: #fff;
    overflow: hidden;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;

    >span {
        color: black;
        font-weight: bold;
        margin-left: 8px;
        padding-right: 2px;
        line-height: 1.25;
        text-align: left;
        white-space: normal;
    }
}

.download-btn:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.download-btn img {
    width: 36px;
    height: 40px;
    object-fit: contain;
}

.phone-images {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    // height: 500px;
}

.phone1,
.phone2 {
    // max-width: 220px;
    height: auto;
    // box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07);
    // border-radius: 30px;
    // position: absolute;
}

.phone1 {
    // transform: rotate(-5deg);
    max-width: 50%;
    left: 90px;
    bottom: 0;
}

.phone2 {
    // transform: rotate(5deg);
    max-width: 40%;
    right: 0;
    bottom: 80px;
    padding: 15px;
}

/* 响应式设计 */
// @media (max-width: 992px) {
//     .content-wrapper {
//         flex-direction: column;
//     }
//     .container {
//         padding-right: 0;
//         margin-bottom: 50px;
//     }
//     .phone-images {
//         height: 400px;
//     }
// }

// @media (max-width: 576px) {
//     .download {
//         padding: 0 20px;
//     }
//     .download-btn {
//         width: 160px;
//         height: 50px;
//     }
//     .phone-images {
//         height: 300px;
//     }
//     .phone1, .phone2 {
//         max-width: 150px;
//     }
// }</style>
